import React from "react";
import {useNavigate} from "react-router-dom";
import updateInput from "../utils/update_input";
import PollingMessage from "../components/PollingMessage";
import SearchOrganisms from "../components/SearchOrganisms";
import {useErrorBoundary} from "react-error-boundary";
import {Helmet} from "react-helmet-async";


const SearchmultipleProteins = () => {

    document.title = "STRING: functional protein association networks";
    const { showBoundary } = useErrorBoundary();

    const navigate = useNavigate();
    const [polling, setPolling] = React.useState<boolean>(false);

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        let submit_button = document.getElementsByClassName("large_submit_button")[0] as HTMLButtonElement;
        submit_button.disabled = true;
        submit_button.classList.add("large_submit_button_active");

        if (event.currentTarget.species_text.value === "") {
            event.currentTarget.species_text.value = "auto-detect";
        }

        try {
            setPolling(true);
            let limit_ = "0";
            let identifiers_ = event.currentTarget.identifier.value.replaceAll('', '').replaceAll('\n', '%0d').replaceAll(',', '%0d');
            let identifiers_list = identifiers_.split('%0d');
            // remover empty strings from the array
            identifiers_list = identifiers_list.filter(function (el : string) {
                return el !== "";
            });

            if (identifiers_list.length === 1) {
                limit_ = "10";
            }
            const result = await updateInput(
                "MultipleProteins", event.currentTarget.species_text.value,
                identifiers_,
                event.currentTarget.requiredScore.value, event.currentTarget.networkType.value, "evidence",
                limit_, "0", "on", "on", "on", "on",
                "on", "on", "on", event.currentTarget.net_fdr.value, ""
            );
            if (result?.path === 'Not found') {
                navigate('/error', {state: result.newData});
                return;
            }

            if (result) {
                navigate(result.path, {state: result.newData});
                return;
            }
        } catch (error) {
            setTimeout(() => {showBoundary(error);}, 2000); // Delay of 2 seconds
        }
        submit_button.disabled = false;
    }

    const toggleAdvancedSettings = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        let as_multiple_identifiers_wrapper = document.getElementById("as_multiple_identifiers_wrapper");
        let settings_button = document.getElementsByClassName("settings_button")[0];
        if (!as_multiple_identifiers_wrapper) {
            return;
        }
        if (as_multiple_identifiers_wrapper.style.display === "none") {
            as_multiple_identifiers_wrapper.style.display = "block";
            settings_button.classList.add("active_button");
        } else {
            as_multiple_identifiers_wrapper.style.display = "none";
            settings_button.classList.remove("active_button");
        }
    }

    const toggleInputExample = (event: React.MouseEvent<HTMLButtonElement>, id: string) => {

        event.preventDefault();

        let example_button1 = document.getElementById("1");
        let example_button2 = document.getElementById("2");
        let example_button3 = document.getElementById("3");

        if (id === "1") {
            example_button1?.classList.add("active_button");
            example_button2?.classList.remove("active_button");
            example_button3?.classList.remove("active_button");

            let input = document.getElementById("primary_input:multiple_identifiers") as HTMLTextAreaElement | null;
            if (input) {
                input.setAttribute("value", "trpA\ntrpB\nTRPC_ECOLI\nb1263");
                input.innerHTML = "trpA\ntrpB\nTRPC_ECOLI\nb1263";
                input.value = "trpA\ntrpB\nTRPC_ECOLI\nb1263";
            }

            let organism_input = document.getElementById("species_text") as HTMLInputElement | null;
            if (organism_input) {
                organism_input?.setAttribute("value", "Escherichia coli str. K-12 substr. MG1655");
                organism_input.innerHTML = "Escherichia coli str. K-12 substr. MG1655";
                organism_input.value = "Escherichia coli str. K-12 substr. MG1655";
            }

            let network_type_selector = document.getElementById('network_type_multiple_identifiers_select');
            let network_type_selector_option = network_type_selector?.querySelector('option[value="functional"]') as HTMLOptionElement;
            if (network_type_selector_option) {
                network_type_selector_option.selected = true;
                (network_type_selector as HTMLOptionElement).value = network_type_selector_option.value;
            }

            let required_score_selector = document.getElementById('required_score_multiple_identifiers_select');
            let required_score_option = required_score_selector?.querySelector('option[value="400"]') as HTMLOptionElement;
            if (required_score_option) {
                required_score_option.selected = true;
                (required_score_selector as HTMLOptionElement).value = required_score_option.value;
            }

            let net_fdr_selector = document.getElementById('net_fdr_select');
            let net_fdr_option = net_fdr_selector?.querySelector('option[value="0.05"]') as HTMLOptionElement;
            if (net_fdr_option) {
                net_fdr_option.selected = true;
                (net_fdr_selector as HTMLOptionElement).value = net_fdr_option.value;
            }

        } else if (id === "2") {
            example_button2?.classList.add("active_button");
            example_button1?.classList.remove("active_button");
            example_button3?.classList.remove("active_button");

            let input = document.getElementById("primary_input:multiple_identifiers") as HTMLTextAreaElement | null;
            if (input) {
                input.setAttribute("value", "ANP1_YEAST\nYJR075W\nVAN1\nOLE1\nMNN11");
                input.innerHTML = "ANP1_YEAST\nYJR075W\nVAN1\nOLE1\nMNN11";
                input.value = "ANP1_YEAST\nYJR075W\nVAN1\nOLE1\nMNN11";
            }

            let organism_input = document.getElementById("species_text") as HTMLInputElement | null;
            if (organism_input) {
                organism_input?.setAttribute("value", "Saccharomyces cerevisiae");
                organism_input.innerHTML = "Saccharomyces cerevisiae";
                organism_input.value = "Saccharomyces cerevisiae";
            }

            let network_type_selector = document.getElementById('network_type_multiple_identifiers_select');
            let network_type_selector_option = network_type_selector?.querySelector('option[value="functional"]') as HTMLOptionElement;
            if (network_type_selector_option) {
                network_type_selector_option.selected = true;
                (network_type_selector as HTMLOptionElement).value = network_type_selector_option.value;
            }

            let required_score_selector = document.getElementById('required_score_multiple_identifiers_select');
            let required_score_option = required_score_selector?.querySelector('option[value="400"]') as HTMLOptionElement;
            if (required_score_option) {
                required_score_option.selected = true;
                (required_score_selector as HTMLOptionElement).value = required_score_option.value;
            }

            let net_fdr_selector = document.getElementById('net_fdr_select');
            let net_fdr_option = net_fdr_selector?.querySelector('option[value="0.05"]') as HTMLOptionElement;
            if (net_fdr_option) {
                net_fdr_option.selected = true;
                (net_fdr_selector as HTMLOptionElement).value = net_fdr_option.value;
            }

        } else if (id === "3") {
            example_button3?.classList.add("active_button");
            example_button1?.classList.remove("active_button");
            example_button2?.classList.remove("active_button");

            let input = document.getElementById("primary_input:multiple_identifiers") as HTMLTextAreaElement | null;
            if (input) {
                input.setAttribute("value", "smoothened, patched, hedgehog, cubitus interruptus");
                input.innerHTML = "smoothened, patched, hedgehog, cubitus interruptus";
                input.value = "smoothened, patched, hedgehog, cubitus interruptus";
            }

            let organism_input = document.getElementById("species_text") as HTMLInputElement | null;
            if (organism_input) {
                organism_input?.setAttribute("value", "Drosophila melanogaster");
                organism_input.innerHTML = "Drosophila melanogaster";
                organism_input.value = "Drosophila melanogaster";
            }

            let network_type_selector = document.getElementById('network_type_multiple_identifiers_select');
            let network_type_selector_option = network_type_selector?.querySelector('option[value="functional"]') as HTMLOptionElement;
            if (network_type_selector_option) {
                network_type_selector_option.selected = true;
                (network_type_selector as HTMLOptionElement).value = network_type_selector_option.value;
            }

            let required_score_selector = document.getElementById('required_score_multiple_identifiers_select');
            let required_score_option = required_score_selector?.querySelector('option[value="400"]') as HTMLOptionElement;
            if (required_score_option) {
                required_score_option.selected = true;
                (required_score_selector as HTMLOptionElement).value = required_score_option.value;
            }

            let net_fdr_selector = document.getElementById('net_fdr_select');
            let net_fdr_option = net_fdr_selector?.querySelector('option[value="0.05"]') as HTMLOptionElement;
            if (net_fdr_option) {
                net_fdr_option.selected = true;
                (net_fdr_selector as HTMLOptionElement).value = net_fdr_option.value;
            }
        }
    }

    return (
        <>
            <Helmet>
                <title> STRING: functional protein association networks</title>
            </Helmet>

            {polling ? (
                <PollingMessage/>) : (
                <div className="menu_content">
                    <div className="search_input_wrap">
                        <div className="search_input_box">
                            <div className="box_title">Multiple Proteins by<br/>Names / Identifiers</div>
                            <div className="box">
                                <form id="input_form_multiple_identifiers" onSubmit={handleSubmit}
                                      method="post" spellCheck="false" encType="multipart/form-data">
                                    <div>
                                        <input type="hidden" name="sessionId" value="btoPeBXp5k4Z"/>
                                        <input type="hidden" name="have_user_input" value="2"/>
                                    </div>
                                    <div className="row_100">
                                        <div className="wrap_input_with_examples">
                                            <label className="label">List of Names (one-per-line):</label>
                                            <span className="example_small">
                                                <button className="string_example small_button" id={"1"}
                                                        onClick={(e) => toggleInputExample(e, "1")}>1</button>
                                                &nbsp;&nbsp;
                                                <button className="string_example small_button" id={"2"}
                                                        onClick={(e) => toggleInputExample(e, "2")}>2</button>
                                                &nbsp;&nbsp;
                                                <button className="string_example small_button" id={"3"}
                                                        onClick={(e) => toggleInputExample(e, "3")}>3</button>

                                        </span>
                                            <div className="wrap_search_item">
                                    <textarea className="input submit_on_enter"
                                              style={{minHeight: "115px"}}
                                              id="primary_input:multiple_identifiers"
                                              name="identifier"
                                              autoComplete="on"
                                              required>
                                    </textarea>
                                                <input name="targetmode" type="hidden" value="proteins"/>
                                            </div>
                                        </div>
                                    </div>
                                    <SearchOrganisms/>
                                    <div className="row_100">
                                        <div className="wrap_input_with_examples">
                                            <button className="settings_button"
                                                    onClick={toggleAdvancedSettings}>Advanced
                                                Settings
                                            </button>
                                            <div className="wrap_search_item">
                                                <div id="as_multiple_identifiers_wrapper"
                                                     className="advanced_settings_wrapper"
                                                     style={{display: "none"}}>
                                                    <div className="advanced_settings_options"
                                                         id="as_multiple_identifiers_options">
                                                        <div style={{display: "table"}}>
                                                            <div style={{display: "table-row"}}>
                                                                <div className="advanced_settings_options_labels">
                                                                    Network Type:&nbsp;&nbsp;
                                                                </div>
                                                                <div className="data_settings_select_wrap">
                                                                    <select
                                                                        name="networkType"
                                                                        id="network_type_multiple_identifiers_select"
                                                                        className="data_settings_select"
                                                                        style={{width: "100%"}}
                                                                        autoComplete="off"
                                                                        defaultValue="functional"
                                                                    >
                                                                        <option value="functional">full STRING network
                                                                        </option>
                                                                        <option value="physical">physical subnetwork
                                                                        </option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div style={{display: 'table-row'}}>
                                                                <div className="advanced_settings_options_labels">
                                                                    Required score:&nbsp;&nbsp;
                                                                </div>
                                                                <div className="data_settings_select_wrap">
                                                                    <select
                                                                        name="requiredScore"
                                                                        id="required_score_multiple_identifiers_select"
                                                                        className="data_settings_select"
                                                                        autoComplete="off"
                                                                        defaultValue="400" // Set the value for the default selected option
                                                                    >
                                                                        <option value="900">highest confidence (0.900)
                                                                        </option>
                                                                        <option value="700">high confidence (0.700)
                                                                        </option>
                                                                        <option value="400">medium confidence (0.400)
                                                                        </option>
                                                                        <option value="150">low confidence (0.150)
                                                                        </option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div style={{display: 'table-row'}}>
                                                                <div className="advanced_settings_options_labels">
                                                                    FDR&nbsp;stringency:&nbsp;
                                                                </div>
                                                                <div className="data_settings_select_wrap">
                                                                    <select
                                                                        name="net_fdr"
                                                                        id="net_fdr_select"
                                                                        className="data_settings_select"
                                                                        autoComplete="off"
                                                                        defaultValue="0.05" // Set the value for the default selected option
                                                                    >
                                                                        <option value="0.01">high (1 percent)
                                                                        </option>
                                                                        <option value="0.05">medium (5 percent)
                                                                        </option>
                                                                        <option value="0.25">lenient (25 percent)
                                                                        </option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit" className="button large_submit_button">
                                        <div></div>
                                        &nbsp;Search&nbsp;
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className={"shadow"}></div>
                </div>
            )}
        </>
    );
}

export default SearchmultipleProteins;